import { ToggleRefinement } from 'react-instantsearch-dom'

export default function Offers() {
    return (
        <div>
            <div className="ais-Heading mb18">Specialūs pasiūlymai</div>
            <ToggleRefinement attribute="has_free_shipping" label="Nemokamas pristatymas" value={1} />
            <ToggleRefinement attribute="has_discount" label="Su nuolaida" value={1} />
        </div>
    )
}
